import React from "react";

import successicon from "../../pages/dashboard/assets/success-icon.svg";
import { Modal } from "../modal";
import "./success.modal.css";

export const SuccessModal = ({ url, message, onCloseClick, show } = {}) => {
  return (
    <Modal show={show} onCloseClick={onCloseClick} name="success-modal">
      <div className="success-modal">
        <img src={successicon} alt="close-modal" className="" />
        <p className="message">{message}</p>
        <button to={url} onClick={onCloseClick} className="action-btn">
          Close
        </button>
      </div>
    </Modal>
  );
};
